/* Copyright (c) 2024 MOCA Systems, Inc.  All rights reserved. */

import { Directive, ElementRef, HostBinding, inject } from '@angular/core';
import { MultiPanelService } from '../multi-panel.service';

@Directive({
	selector: '[multiPanelItem]',
	standalone: true,
})
export class MultiPanelItemDirective {
	private multiPanelService = inject(MultiPanelService);

	private _id: string;

	public get id(): string {
		return this._id;
	}

	@HostBinding('style.pointerEvents') public pointerEvents: string;
	@HostBinding('style.grid-column-start') public gridColumnStart: number;
	@HostBinding('style.grid-column-end') public gridColumnEnd: number;
	@HostBinding('style.grid-row-start') public gridRowStart: number;
	@HostBinding('style.grid-row-end') public gridRowEnd: number;

	/**
		Opting to keep the input 0-indexed
	 */
	public setLayout(columnStart: number, columnEnd: number, rowStart: number, rowEnd: number) {
		this.gridColumnStart = columnStart + 1;
		this.gridColumnEnd = columnEnd + 1;
		this.gridRowStart = rowStart + 1;
		this.gridRowEnd = rowEnd + 1;
	}

	constructor(private elementRef: ElementRef) {}

	ngOnInit(): void {
		this._id = this.multiPanelService.requestNewId();

		// better solution than setting this manually for each panel, this is probably
		// the line where it'd have been better to make this directive a component though
		this.pointerEvents = 'auto';
	}
}
